<template>
  <div class="menuBody" style="margin-left:25px;">
    <div class="menuTool">
      <el-card class="box-card">
        <el-row :gutter="10">
          <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'sys:web:role:manage:add'" @click="RoleAdd()">角色添加</el-button>
            <el-table tooltip-effect="light"  :data="tableData" v-loading="loading" style="width: 100%;height:490px;margin-bottom: 20px;overflow-y: scroll;margin-top:20px" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="roleName" label="角色名称"></el-table-column>
    <el-table-column show-overflow-tooltip prop="officeName" label="归属机构"></el-table-column>
    <el-table-column  show-overflow-tooltip prop="dataScope" label="数据范围">
      <template slot-scope="scope">
        <el-tag v-if="scope.row.dataScope=='1'" >所有数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='2'" >所在公司及以下数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='3'" >所在公司数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='4'" >所在部门及以下数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='5'" >所在部门数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='6'" >所在项目及以下数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='7'" >所在小区及以下数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='8'" >仅本人数据</el-tag>
        <el-tag v-if="scope.row.dataScope=='9'" >按明细设置</el-tag>
      </template>
    </el-table-column>
    <el-table-column  width="220" label="操作">
     <template slot-scope="scope">
       <!-- v-Jurisdiction="'sys:web:role:manage:update'" -->
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small"
        v-Jurisdiction="'sys:web:role:manage:update'"
                     title="修改"></el-button>
          <el-button @click="addNextMenu(scope.row)" type="success" icon="el-icon-s-operation"   circle
          v-Jurisdiction="'sys:web:role:manage:addUser'"
                     size="small" title="分配"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" v-debounce icon="el-icon-delete" circle size="small"
          v-Jurisdiction="'sys:web:role:manage:delete'"
                     title="删除"></el-button>
        </template>
    </el-table-column>
  </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange" 
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper" 
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
    <RoleManagementDialog :param="diaLogData" @Visible="Visible" ref="RoleManagementDialog"/>
    <RoleManagementAllocation ref="RoleManagementAllocation"/>
  </div>
</template>

<script>
import RoleManagementDialog from "../common/RoleManagementDialog";
import RoleManagementAllocation from "../common/RoleManagementAllocation"

export default {
  name: "RoleManagement",
  components: {RoleManagementDialog,RoleManagementAllocation},
  data() {
    return {
      loading:false,
       total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        input2:"",
      tableData: [],
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
        osData:[],
        menuTree:[],
      },
    }
  },
  methods: {
        handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    getAllMenu() {
      let PageSize ={
         "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
      }
      this.$http.post(this.$requestUrl.POST_ROLE_LIST,PageSize).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.tableData = result.data.records;
          this.total = result.data.total
          this.loading = false
        } else {
          this.$message.error(result.msg)
          this.loading = false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
        this.loading = false
      })
    },
    RoleAdd(){
        // 角色添加
        let row = {}
         this.$refs.RoleManagementDialog.title = "添加角色";
         this.$refs.RoleManagementDialog.dialogVisible = true;
         this.$refs.RoleManagementDialog.osData = this.osData
         this.$refs.RoleManagementDialog.menuTree = this.menuTree
         this.$refs.RoleManagementDialog.formLabelAlign= row;
    },
    editMenu(row) { // 修改
    let obj = {}
    obj.row = row
         this.$http.get(this.$requestUrl.GET_ROLE_DETAILS+row.roleId).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          obj.roleDetails = result.data.roleDetails
         this.$refs.RoleManagementDialog.title = "修改角色";
         this.$refs.RoleManagementDialog.dialogVisible = true;
         this.$refs.RoleManagementDialog.osData = this.osData
         this.$refs.RoleManagementDialog.menuTree = this.menuTree
         this.$refs.RoleManagementDialog.formLabelAlign = obj;
        }else{
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    addNextMenu(row) { // 分配
      this.$refs.RoleManagementAllocation.title = "角色分配";
      this.$refs.RoleManagementAllocation.dialogVisi = true;
      this.$refs.RoleManagementAllocation.res = row;
      this.$refs.RoleManagementAllocation.osData = this.osData
    },
    delMenu(row) { // 删除
  this.$confirm('是否确认要删除该角色?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
    this.$http.delete(this.$requestUrl.DELETE_ROLE+row.roleId).then((res) => {
          if(res.data.code == 200){
                 this.$message({
            type: 'success',
            message: '删除成功!'
          });
             this.getAllMenu()
          }else{
             this.getAllMenu()
          this.$message({
            type: 'warning',
            message: '删除失败'
          });
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
        getUserOffice() {
            let obj = {
                "treeGroup":1,
                "officeType":"1",
                "grade":"1"
            }
      this.$http.post(this.$requestUrl.GET_USER_OFFICE_TREE,obj).then((res) => {
        let data = res.data.data;
          this.osData = data
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    getAllMenuTree() {
          let obj = {
            "delFlag": "",
            "menuType": "0",
            "isShow": ""
          }
      this.$http.post(this.$requestUrl.GET_ALL_MENU, obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          if (result.data == null) {
          } else {
            for (let val of result.data) {
              val.label = val.name
              val.value = val.id
              if (val.children.length != 0) {
                this.circulation(val.children)
              }
            }
            this.menuTree = result.data;
          }
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    circulation(children) {
      for (let res of children) {
        res.label = res.name
        res.value = res.id
        if (res.children.length != 0) {
          this.circulation(res.children)
        }
      }
    },
    Visible(data){
      if(data == false){
        this.getAllMenu()
      }
    }
  },
  mounted() {
    this.getAllMenu();
    this.getUserOffice()
    this.getAllMenuTree()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>